import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import ProblemBento from "@/components/sections/ProblemBento";
import DeathWindow from "@/components/sections/DeathWindow";
import Architecture from "@/components/sections/Architecture";
import Advantage from "@/components/sections/Advantage";
import Authority from "@/components/sections/Authority";
import LeadForm from "@/components/sections/LeadForm";

export default function Landing() {
  return (
    <div className="relative">
      <Navbar />
      <main>
        <Hero />
        <ProblemBento />
        <DeathWindow />
        <Architecture />
        <Advantage />
        <Authority />
        <LeadForm />
      </main>
      <Footer />
    </div>
  );
}
